import React from 'react';
import { Typography, Button } from '@mui/material';
import '../styles/common.css';
import langDetails from '../components/MultiLanguage/language.json';

const LetsGoBeforeFinish = ({ sharedData, updateSharedData, handleNext }) => {
  const lang = langDetails[sharedData?.language];

  const onClickLetsGo = (isemailoptIn) => {
    const updatedData = {
      ...sharedData,
      isemailoptIn
    };
    updateSharedData(updatedData);
    handleNext(4);
  }

  return (
      <div style={{textAlign: 'center'}}>
        <div>
            <Typography className='big-head mb-30' style={{ paddingTop: 20, color: '#111' }}>{lang?.wait}</Typography>
            <Typography className="query-head mt-10" style={{ color: '#111111' }}>{lang?.beforeWeFinish}</Typography>
            <Typography className="lg-normal-text mb-30 mt-10" style={{ color: '#111111' }}>{lang?.areYouOkIfWeShareEmail}</Typography>
        </div>
        <Button className="normal-text next-btn" variant='contained' onClick={()=>onClickLetsGo(true)}>
          {lang?.letsGo}
        </Button>
      <div style={{ textAlign: 'center' }}>
          <Typography className="normal-text mb-10 mt-20" onClick={()=>onClickLetsGo(false)} style={{color: '#111111BF', cursor: 'pointer'}}>{lang?.noThanks}!</Typography>
      </div>
    </div>
  );
}

export default LetsGoBeforeFinish;

